<template>
    <div class="chart-container">
      <div class="title">
        <h2>国家视角最佳安全防范措施部署情况</h2>
      </div>
      <div class="countryList">
        <div class="countryListIn" v-for="(item,index) in country" :class="getItemClass(index)" >
           <h2>No.{{item.rank}} {{item.name}}</h2>
          <img :src="getPng(item.img)" alt="">
          <div class="progress">
            <div class="progressIn" :style="{ width: item.percentage + '%' }"></div>
          </div>
          <h3>{{item.percentage}}%</h3>
        </div>
      </div>
    </div>
</template>
<script>
import {getNationalDeploymentSituation} from "@/service/dashboard";
import {countryChineseDict, countryDict} from "@/theme/dict";

export default {
  data() {
    return {
      country:[
        {name:"美国",percentage:"85",img:require("../../assets/Flags/US.png")},
        {name:"中国",percentage:"83", img:require("../../assets/Flags/CN.png")},
        {name:"新加坡",percentage:"81",img:require("../../assets/Flags/SG.png")},
        {name:"日本",percentage:"79", img:require("../../assets/Flags/JP.png")},
        {name:"印度",percentage:"73", img:require("../../assets/Flags/IN.png")}
      ]
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getPng(name) {
      return require(`../../assets/Flags/${name}.png`);
    },
    getMirrorName(obj,name) {
      const result = Object.entries(obj).find(([key, val]) => val === name);

      return result ? result[0] : null;
    },
    getChineseName(shortName) {
      const foreignFullName = countryDict[shortName];
      const chineseName = countryChineseDict[foreignFullName];

      return chineseName;
    },
    sortByScoreDescending(items) {
      return items.sort((a, b) => b.score - a.score);
    },
    getData(){
      getNationalDeploymentSituation().then(res => {
        //返回值排序
        let data = res.map(item =>{
          return {
            name : this.getChineseName(item.name)?? "多米尼克",
            rank: item.rank,
            percentage : item.score,
            img : item.name
          };
        });

        this.country = data;
      });
    },
    getItemClass(index) {
      if (index === 0){
        return "countryListActive";
      } else if (index >2){
        return "countryListActiveFour";
      }
    }
  }
};
</script>
<style lang="less" scoped>
.chart-container {
    width: 100%;
    height: 100%;
    background: linear-gradient(to right, rgba(73, 74, 98, 0.3), rgba(108, 111, 157, 0.2));
    border-radius: 10px;
    padding-top: 10px;
    padding-left: 15px;
    box-sizing: border-box;
    h2{
      color: rgba(241, 237, 255, 1);
      font-family: 'YouSheBiaoTiHei';
      font-size: 24px;
      height: 31px;
      text-align: left;
      padding-left: 26px;
      text-shadow: 0 2px 20px rgba(42, 56, 180, 1) ;
    }
    h3{
      color: rgba(241, 237, 255, 1);
      font-family: 'YouSheBiaoTiHei';
      font-size: 32px;
      height: 31px;
      text-align: left;
      padding-left: 26px;
      text-shadow: 0 2px 20px rgba(42, 56, 180, 1) ;
      position: absolute;
      left: 44%;
      top: 20%;
    }

  .countryList{
    height: 800px;
    padding-top: 11px;
    .countryListIn{
      width: 347px;
      margin-left: 22px;
      margin-bottom: 15px;
      height: 88px;
      background: url("../../assets/Precautions/no2.png") no-repeat;
      background-size: 100%;
      position: relative;
      h2{
        font-size: 12px;
        height: 31px;
        text-align: left;
        padding-left: 48px;
        padding-top: 14px;
      }

      img{
        position: absolute;
        left:16%;
        top: 48%;
        width: 47px;
        height: 30px ;
      }

      .progress{
        width: 156px;
        height: 10px;
        border: 0.2px solid rgba(178, 181, 255, 0.3);
        border-radius: 2px;
        padding-top: 3px;
        padding: 2px 2px 0;
        position: absolute;
        left: 42%;
        top: 65%;
        div{
          position: relative;
          background: linear-gradient(#5E6EFF,#8287F7);
          height: 6px;
          border-radius: 2px;
          border: 0.2px solid rgba(201, 200, 200, 0.1);
        }
        .progressIn::after {
          content: ''; /* 伪元素需要内容才能显示 */
          position: absolute; /* 绝对定位 */
          top: 1px; /* 阴影位于边框上方 */
          left: 1px; /* 阴影位于边框左侧 */
          right: 1px; /* 阴影位于边框右侧 */
          bottom: 1px; /* 阴影位于边框下方 */
          box-shadow: 0 0 20px rgba(236, 233, 233, 0.7); /* 添加阴影 */
          z-index: -1; /* 确保阴影在元素下方 */
        }
      }
    }
    .countryListActive{
      width: 390px;
      height: 185px;
      margin-bottom: 15px;
      background: url("../../assets/Precautions/no1.png") no-repeat;
      background-size: 100%;
      position: relative;
      left: -25px;
      h2{
        font-size: 18px;
        height: 31px;
        text-align: left;
        padding-left: 64px;
        padding-top: 29px;
      }

      img{
        position: absolute;
        left:16%;
        top: 38%;
        width: 94px;
        height: 58px;
      }
      .progress{
        position: absolute;
        left: 46%;
        top: 67%;
        height: 13px;
        .progressIn{
          height: 8px;
        }
      }

      h3{
        font-size: 47px;
        left: 38%;
        top: 34%;
      }
    }

    .countryListActiveFour{
      background: url("../../assets/Precautions/no4.png") no-repeat;
      background-size: 100%;
    }
  }
}
</style>
